export const useSoundDetectionTranslations = {
  recordingFailed: {
    en: 'Failed to start audio assessment. Please make sure you have both mic and speaker access',
    es: 'No se pudo comenzar la evaluación del audio. Asegúrate de permitir el acceso tanto al micrófono como al altavoz.',
    ar: 'فشل بدء التقييم الصوتي. يرجى التأكد من أن لديك إمكانية الوصول إلى الميكروفون ومكبر الصوت',
    he: 'Failed to start audio assessment. Please make sure you have both mic and speaker access',
    fr: "Échec du démarrage de l'évaluation audio. Veuillez vous assurer d'avoir accès au micro et au haut-parleur",
    ro: 'Nu a reușit să pornească evaluarea audio. Vă rugăm să vă asigurați că aveți acces la microfon și difuzor',
    nl: 'Kan audio-evaluatie niet starten. Zorg ervoor dat u toegang heeft tot zowel de microfoon als de luidspreker',
    pl: 'Nie udało się rozpocząć oceny audio. Upewnij się, że masz dostęp zarówno do mikrofonu, jak i głośnika',
  },
  soundNotMatchingWords: {
    en: "Sorry! We failed to match the microphone's sound with the speaker input. Get a quiet place and retry",
    es: 'El sonido del micrófono no coincide con la entrada del altavoz. Ve a un lugar tranquilo e inténtalo de nuevo.',
    ar: 'آسف! لقد فشلنا في مطابقة صوت الميكروفون مع إدخال مكبر الصوت. احصل على مكان هادئ ثم أعد المحاولة',
    he: "Sorry! We failed to match the microphone's sound with the speaker input. Get a quiet place and retry",
    fr: "Désolé ! Nous n'avons pas pu faire correspondre le son du micro avec l'entrée du haut-parleur. Trouvez un endroit calme et réessayez",
    ro: 'Ne pare rău! Nu am reușit să potrivim sunetul microfonului cu intrarea difuzorului. Găsiți un loc liniștit și încercați din nou',
    nl: 'Sorry! We konden het geluid van de microfoon niet matchen met de invoer van de luidspreker. Zoek een stille plek en probeer het opnieuw',
    pl: 'Przepraszamy! Nie udało się dopasować dźwięku z mikrofonu do wejścia głośnika. Znajdź ciche miejsce i spróbuj ponownie',
  },
  done: {
    en: 'Done',
    es: 'Hecho',
    ar: 'تم',
    he: 'Done',
    fr: 'Terminé',
    ro: 'Gata',
    nl: 'Klaar',
    pl: 'Gotowe',
  },
  analyzingWait: {
    en: 'Analyzing! Please wait...',
    es: 'Analizando. Espera un momento.',
    ar: 'تحليل! انتظر من فضلك...',
    he: 'Analyzing! Please wait...',
    fr: 'Analyse en cours ! Veuillez patienter...',
    ro: 'Analiză în curs! Vă rugăm să așteptați...',
    nl: 'Bezig met analyseren! Even geduld...',
    pl: 'Analizowanie! Proszę czekać...',
  },
  loadingWait: {
    en: 'Checking audio support! Please wait...',
    es: 'Evaluando el audio. Espera un momento.',
    ar: 'التحقق من دعم الصوت! انتظر من فضلك...',
    he: 'Checking audio support! Please wait...',
    fr: 'Vérification de la prise en charge audio ! Veuillez patienter...',
    ro: 'Se verifică suportul audio! Vă rugăm să așteptați...',
    nl: 'Audio-ondersteuning controleren! Even geduld...',
    pl: 'Sprawdzanie wsparcia audio! Proszę czekać...',
  },
  evaluatingMic: {
    en: 'Evaluating the Microphone. Please wait...',
    es: 'Evaluando el micrófono. Espera un momento.',
    ar: 'تقييم الميكروفون. انتظر من فضلك...',
    he: 'Evaluating the Microphone. Please wait...',
    fr: 'Évaluation du microphone. Veuillez patienter...',
    ro: 'Se evaluează microfonul. Vă rugăm să așteptați...',
    nl: 'Microfoon evalueren. Even geduld...',
    pl: 'Ocenianie mikrofonu. Proszę czekać...',
  },
  analyzingFailed: {
    en: 'Sorry! Failed to analyze the audio. Please retry.',
    es: 'No se pudo analizar el audio. Inténtalo de nuevo.',
    ar: 'آسف! فشل في تحليل الصوت. الرجاء اعادة المحاولة.',
    he: 'Sorry! Failed to analyze the audio. Please retry.',
    fr: "Désolé ! Échec de l'analyse de l'audio. Veuillez réessayer.",
    ro: 'Ne pare rău! Analiza audio a eșuat. Vă rugăm să încercați din nou.',
    nl: 'Sorry! Audio-analyse mislukt. Probeer het opnieuw.',
    pl: 'Przepraszamy! Nie udało się przeanalizować audio. Proszę spróbować ponownie.',
  },
  audioFileNotLoaded: {
    en: 'Sorry! We failed to process the audio on the device. Please retry.',
    es: 'No se pudo procesar el audio en el dispositivo. Inténtalo de nuevo.',
    ar: 'آسف! لقد فشلنا في معالجة الصوت على الجهاز. الرجاء اعادة المحاولة.',
    he: 'Sorry! We failed to process the audio on the device. Please retry.',
    fr: "Désolé ! Nous n'avons pas pu traiter l'audio sur l'appareil. Veuillez réessayer.",
    ro: 'Ne pare rău! Nu am reușit să procesăm sunetul pe dispozitiv. Vă rugăm să încercați din nou.',
    nl: 'Sorry! We konden het geluid niet verwerken op het apparaat. Probeer het opnieuw.',
    pl: 'Przepraszamy! Nie udało się przetworzyć audio na urządzeniu. Proszę spróbować ponownie.',
  },
  voiceNotReady: {
    en: 'The voice assistant is not ready. Please wait a few seconds and try again.',
    es: 'El asistente de voz no está listo. Espera unos segundos e inténtalo de nuevo.',
    ar: 'المساعد الصوتي غير جاهز. يرجى الانتظار بضع ثوان وحاول مرة أخرى.',
    he: 'The voice assistant is not ready. Please wait a few seconds and try again.',
    fr: "L'assistant vocal n'est pas prêt. Veuillez patienter quelques secondes et réessayer.",
    ro: 'Asistentul vocal nu este gata. Vă rugăm să așteptați câteva secunde și să încercați din nou.',
    nl: 'De spraakassistent is niet klaar. Wacht een paar seconden en probeer het opnieuw.',
    pl: 'Asystent głosowy nie jest gotowy. Proszę poczekać kilka sekund i spróbować ponownie.',
  },
};
